export const ListQueryKey = 'projectProjectLotteryRecords';
export const DetailQueryKey = 'projectProjectLotteryRecord';
export const Urls = {
  selectUrl: '/acitivity/raffle/records',
  updateUrl: '',
  deleteUrl: '',
  createUrl: '',
  detailUrl: ''
};